// removed by extract-text-webpack-plugin
module.exports = {"overlay":"_3NE0gpjv9mRyJ_r-CH9TqD","invisible":"_1UWHzh8KXbFFpZ2bUxEL2k","backdrop":"_3DcTX5sI1HU32LNiG58f7_","active":"_8P2nGWiQkPBChlqjLn3h6"};


//////////////////
// WEBPACK FOOTER
// ../~/react-toolbox/lib/overlay/theme.scss
// module id = 999
// module chunks = 0